import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import moment from 'moment';
import { getTransactionsReport as fetchTransactionsReport } from '../../Reporting/reportingActions';
import { getIsMerchantsLoaded, getMerchants } from '../../Merchants/merchantsEntity';
import {
    getIsTransactionsReportLoading,
    getTransactionsReport,
    getTransactionsReportErrorMessage
} from '../../Reporting/reportingEntity';
import {
    EmvioDateRangePicker as DateRangePicker,
    EmvioLoadingSpinner as LoadingSpinner
} from '@nexio/emvio-util-ui';
import emvioChartUtilUi from '@nexio/emvio-chart-util-ui';
import { getMerchantsMapper } from '../../Merchants/merchantsEntity';
import { toastIfError } from '../../../utils/toast';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import './TransactionChart.scss';
import ResellerWidgetSettings from '../Widgets/ResellerWidgetSettings/ResellerWidgetSettings';
import { filterMerchantsByCurrencyAsString } from '../Widgets/ResellerWidgetSettings/resellerWidgetSettingsActions';
import { getResellerWidgetSettingsEntity } from '../Widgets/ResellerWidgetSettings/resellerWidgetSettingsEntity';

// The library ships a minified UMD bundle whose named exports Vite/cjs-module-lexer
// cannot reliably detect, so consume it via the default export and destructure.
const { EmvioLineChart, emvioCurrencyFormatter } = emvioChartUtilUi;

export class TransactionChart extends Component {
    static propTypes = {
        error: PropTypes.string,
        isLoading: PropTypes.bool,
        isMerchantsLoaded: PropTypes.bool,
        merchantsMapper: PropTypes.any,
        onGetTransactionsReport: PropTypes.func.isRequired,
        allMerchants: PropTypes.array,
        settings: PropTypes.any,
        transactionsReport: PropTypes.any.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            dateRange: {
                endDate: moment.utc().endOf('day'),
                startDate: moment.utc().subtract(1, 'years').startOf('month')
            }
        };

        this.dateRangeChanged = this.dateRangeChanged.bind(this);
        this.transformData = this.transformData.bind(this);
    }

    componentDidMount() {
        if (this.props.isMerchantsLoaded) {
            const merchantsForData = filterMerchantsByCurrencyAsString(this.props.allMerchants, this.props.settings);
            this.props.onGetTransactionsReport(merchantsForData, this.state.dateRange, this.props.settings.currencyId);
        }
    }

    componentDidUpdate(prevProps) {
        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isMerchantsLoaded') || doesPropExistAndHasItChanged(prevProps, this.props, 'settings')) {
            const merchantsForData = filterMerchantsByCurrencyAsString(this.props.allMerchants, this.props.settings);

            if (merchantsForData) {
                this.props.onGetTransactionsReport(merchantsForData, this.state.dateRange, this.props.settings.currencyId);
            }
        }

        toastIfError(prevProps, this.props);
    }

    transformData(rawData) {
        rawData = rawData.map((item) => {
            item.date = moment(item.transactionDate).utc();
            item.name = this.props.merchantsMapper[item.merchantId];

            return item;
        });
        rawData = _.groupBy(rawData, 'merchantId');

        let groupedData = Object.values(rawData);

        for (let current = moment(this.state.dateRange.startDate).utc(); current.isBefore(this.state.dateRange.endDate); current.add(1, 'month')) {
            _.forEach(groupedData, (data) => {
                const merchantInfo = data[0];
                const transactionDate = current.format('YYYY-MM-01');
                if (!_.find(data, { transactionDate: transactionDate })) {
                    data.push({
                        amount: 0,
                        date: current.toDate(),
                        merchantId: merchantInfo.merchantId,
                        name: merchantInfo.name,
                        transactionDate: transactionDate
                    });
                }
            });
        }

        let groupedData2 = [];
        _.forEach(groupedData, (data) => {
            groupedData2.push(_.sortBy(data, 'transactionDate'));
        });

        return groupedData2;
    }

    dateRangeChanged(dateRange) {
        this.setState({ dateRange });
        const merchantsForData = filterMerchantsByCurrencyAsString(this.props.allMerchants, this.props.settings);
        this.props.onGetTransactionsReport(merchantsForData, dateRange, this.props.settings.currencyId);
    }

    render() {
        const currencyId = _.get(this.props, 'settings.currencyId', '840');

        return (
            <div className="transaction-widget widget-layout">
                <div className="control-container">
                    <DateRangePicker
                        initialStartDate={this.state.dateRange.startDate}
                        onChange={this.dateRangeChanged}
                    />
                    <ResellerWidgetSettings/>
                </div>
                <div className="chart-container">
                    {this.props.isLoading || !this.props.isMerchantsLoaded
                        ? <LoadingSpinner/>
                        : <EmvioLineChart
                            dateRange={this.state.dateRange}
                            data={this.transformData(this.props.transactionsReport)}
                            dataFormatter={(number) => emvioCurrencyFormatter(number, currencyId)}
                            showLegend={false}
                        />
                    }
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        error: getTransactionsReportErrorMessage(state),
        isLoading: getIsTransactionsReportLoading(state),
        isMerchantsLoaded: getIsMerchantsLoaded(state),
        merchantsMapper: getMerchantsMapper(state),
        settings: getResellerWidgetSettingsEntity(state),
        transactionsReport: getTransactionsReport(state),
        allMerchants: getMerchants(state)
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        onGetTransactionsReport: (merchantIds, dateRange, currencyId) => dispatch(fetchTransactionsReport(merchantIds, dateRange.startDate, dateRange.endDate, currencyId))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TransactionChart);
